import React, { useEffect } from "react";
import {
  initialWeatherInfo,
  otherWeatherInfo,
  weatherError,
  weatherLoading,
  fetchAsyncWeather,
  selectedDate,
  handleDate,
} from "./WeatherSlice";
import "../../css/Weather.css";
import { useDispatch, useSelector } from "react-redux";

interface WeatherProps {
  page: number;
}

const Weather = ({ page }: WeatherProps) => {
  const dispatch = useDispatch();

  //データ受け取り
  const initialWeatherData = useSelector(initialWeatherInfo);
  const otherWeatherData = useSelector(otherWeatherInfo);
  const handledDate = useSelector(selectedDate);

  useEffect(() => {
    //状態が初期値だったらdispatch
    if (page === 1 && initialWeatherData === null) {
      dispatch(fetchAsyncWeather(page));
    } else {
      dispatch(fetchAsyncWeather(page));
    }
  }, [page]);

  return (
    <div className="weather_container">
      <table className="weather_table">
        <thead className="weather_table_head">
          <tr>
            <th>日付</th>
            <th>6~18時</th>
            <th>18~翌6時</th>
            <th>平均</th>
            <th>最高</th>
            <th>最低</th>
            <th>☔️</th>
          </tr>
        </thead>
        <tbody className="weather_table_body">
          {(page === 1 ? initialWeatherData : otherWeatherData)?.map(
            (item, index) => (
              <tr key={index}>
                <td
                  className={item.date == handledDate ? "selected" : ""}
                  onMouseOver={() => dispatch(handleDate(item.date))}
                  onMouseOut={() => dispatch(handleDate(null))}>
                  {item.date}
                </td>
                <td
                  className={item.date == handledDate ? "selected" : ""}
                  onMouseOver={() => dispatch(handleDate(item.date))}
                  onMouseOut={() => dispatch(handleDate(null))}>
                  {item.weather_first}
                </td>
                <td
                  className={item.date == handledDate ? "selected" : ""}
                  onMouseOver={() => dispatch(handleDate(item.date))}
                  onMouseOut={() => dispatch(handleDate(null))}>
                  {item.weather_second}
                </td>
                <td
                  className={item.date == handledDate ? "selected" : ""}
                  onMouseOver={() => dispatch(handleDate(item.date))}
                  onMouseOut={() => dispatch(handleDate(null))}>
                  {item.temps_average}°C
                </td>
                <td
                  className={item.date == handledDate ? "selected" : ""}
                  onMouseOver={() => dispatch(handleDate(item.date))}
                  onMouseOut={() => dispatch(handleDate(null))}>
                  {item.temps_max}°C
                </td>
                <td
                  className={item.date == handledDate ? "selected" : ""}
                  onMouseOver={() => dispatch(handleDate(item.date))}
                  onMouseOut={() => dispatch(handleDate(null))}>
                  {item.temps_min}°C
                </td>
                <td
                  className={item.date == handledDate ? "selected" : ""}
                  onMouseOver={() => dispatch(handleDate(item.date))}
                  onMouseOut={() => dispatch(handleDate(null))}>
                  {item.pop}%
                </td>
              </tr>
            )
          )}
        </tbody>
      </table>
    </div>
  );
};

export default Weather;
